import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import useGetHook from "../../../../../hooks/useGetHook";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const navigationData = await getApiData(APIS.NAVIGATION, {});
  if (!navigationData || !navigationData.data) {
    console.error("Navigation data is not available!");
    return;
  }

  const navLinks = navigationData.data
    .map((link: { path: string; name: string }) => {
      return `<a href="${link.path}" class="text-black hover:border-[var(--primary)] hover:border-b-2 px-2">${link.name}</a>`;
    })
    .join("");

  Components.addType("navbar", {
    isComponent: (el) => {
      if (el.className === "default-navbar") {
        return {
          type: "navbar",
        };
      }
    },

    model: {
      defaults: {
        draggable: true,
        droppable: true,
        components: /*html*/ `
          <nav class="shadow-lg bg-white w-full default-navbar ">
            <div
              class="container mx-auto px-4 py-2 flex items-center justify-between"
            >
              <button id="menu-toggle" class="md:hidden p-2 ">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.2918 6.33326C17.2918 6.49902 17.2259 6.658 17.1087 6.77521C16.9915 6.89242 16.8325 6.95827 16.6668 6.95827H3.33326C3.1675 6.95827 3.00852 6.89242 2.89131 6.77521C2.7741 6.658 2.70825 6.49902 2.70825 6.33326C2.70825 6.1675 2.7741 6.00852 2.89131 5.89131C3.00852 5.7741 3.1675 5.70825 3.33326 5.70825H16.6668C16.8325 5.70825 16.9915 5.7741 17.1087 5.89131C17.2259 6.00852 17.2918 6.1675 17.2918 6.33326ZM17.2918 10.5C17.2918 10.6657 17.2259 10.8247 17.1087 10.9419C16.9915 11.0591 16.8325 11.125 16.6668 11.125H3.33326C3.1675 11.125 3.00852 11.0591 2.89131 10.9419C2.7741 10.8247 2.70825 10.6657 2.70825 10.5C2.70825 10.3342 2.7741 10.1753 2.89131 10.058C3.00852 9.94083 3.1675 9.87498 3.33326 9.87498H16.6668C16.8325 9.87498 16.9915 9.94083 17.1087 10.058C17.2259 10.1753 17.2918 10.3342 17.2918 10.5ZM17.2918 14.6667C17.2918 14.8325 17.2259 14.9914 17.1087 15.1087C16.9915 15.2259 16.8325 15.2917 16.6668 15.2917H3.33326C3.1675 15.2917 3.00852 15.2259 2.89131 15.1087C2.7741 14.9914 2.70825 14.8325 2.70825 14.6667C2.70825 14.5009 2.7741 14.342 2.89131 14.2248C3.00852 14.1076 3.1675 14.0417 3.33326 14.0417H16.6668C16.8325 14.0417 16.9915 14.1076 17.1087 14.2248C17.2259 14.342 17.2918 14.5009 17.2918 14.6667Z"
                    fill="#272727"
                  />
                </svg>
              </button>
              <div class="flex items-center justify-center md:justify-left ">
              <a href="/" class="p-2">
                <img
                  id="navbarLogo"
                  src="https://via.placeholder.com/100"
                  alt="Logo"
                  class="w-20 h-16 md:h-20 cursor-pointer object-contain"
                />
                </a>
              </div>
              <div class="hidden md:flex space-x-6 nav-links">
                ${navLinks}
              </div>
              <div class="flex items-center space-x-4">
                <div
                  class="relative bg-[#F3F4F6] p-2 rounded-full  items-center hidden md:flex"
                >
                  <form method=get action="/search">
                    <input
                      type="text"
                      placeholder="Search"
                      name="search"
                      class="bg-transparent border-none focus:outline-none text-sm px-2"
                    />
                  </form>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.6723 27.5092L21.3398 21.1766M21.3398 21.1766C22.3562 20.1602 23.1624 18.9535 23.7125 17.6255C24.2626 16.2975 24.5457 14.8742 24.5457 13.4368C24.5457 11.9994 24.2626 10.576 23.7125 9.24804C23.1624 7.92004 22.3562 6.71339 21.3398 5.69699C20.3234 4.68058 19.1167 3.87433 17.7887 3.32425C16.4607 2.77418 15.0374 2.49106 13.6 2.49106C12.1626 2.49106 10.7392 2.77418 9.41123 3.32425C8.08323 3.87433 6.87659 4.68058 5.86018 5.69699C3.80746 7.74971 2.65425 10.5338 2.65425 13.4368C2.65425 16.3398 3.80746 19.1239 5.86018 21.1766C7.9129 23.2293 10.697 24.3825 13.6 24.3825C16.503 24.3825 19.2871 23.2293 21.3398 21.1766Z"
                      stroke="#4E4E4E"
                      stroke-width="3.34948"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <a class="flex items-center space-x-1 cursor-pointer  ripple-effect relative" href="/cart">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.8429 25.4989C26.6828 25.4989 27.4883 25.8325 28.0821 26.4264C28.676 27.0202 29.0096 27.8257 29.0096 28.6655C29.0096 29.5054 28.676 30.3108 28.0821 30.9047C27.4883 31.4986 26.6828 31.8322 25.8429 31.8322C25.0031 31.8322 24.1976 31.4986 23.6038 30.9047C23.0099 30.3108 22.6763 29.5054 22.6763 28.6655C22.6763 26.908 24.0854 25.4989 25.8429 25.4989ZM0.509613 0.165527H5.68711L7.17545 3.33219H30.5929C31.0129 3.33219 31.4156 3.49901 31.7125 3.79594C32.0095 4.09287 32.1763 4.4956 32.1763 4.91553C32.1763 5.18469 32.0971 5.45386 31.9863 5.70719L26.3179 15.9514C25.7796 16.9172 24.7346 17.5822 23.5471 17.5822H11.7513L10.3263 20.163L10.2788 20.353C10.2788 20.458 10.3205 20.5587 10.3947 20.6329C10.469 20.7072 10.5696 20.7489 10.6746 20.7489H29.0096V23.9155H10.0096C9.16976 23.9155 8.36431 23.5819 7.77044 22.988C7.17658 22.3942 6.84295 21.5887 6.84295 20.7489C6.84295 20.1947 6.98545 19.6722 7.22295 19.2289L9.37628 15.3497L3.67628 3.33219H0.509613V0.165527ZM10.0096 25.4989C10.8495 25.4989 11.6549 25.8325 12.2488 26.4264C12.8426 27.0202 13.1763 27.8257 13.1763 28.6655C13.1763 29.5054 12.8426 30.3108 12.2488 30.9047C11.6549 31.4986 10.8495 31.8322 10.0096 31.8322C9.16976 31.8322 8.36431 31.4986 7.77044 30.9047C7.17658 30.3108 6.84295 29.5054 6.84295 28.6655C6.84295 26.908 8.25211 25.4989 10.0096 25.4989ZM24.2596 14.4155L28.6613 6.49886H8.64795L12.3846 14.4155H24.2596Z"
                      fill="#4E4E4E"
                    />
                  </svg>
                  <p>Cart</p>

                  <span
                    class="bg-gray md:text-base text-sm px-2 rounded-full text-center absolute -top-4 bg-red-500 text-white" id="cart-count">
                    <!-- {% comment %} -->
                     3
                    <!-- {% endcomment %} -->
                   <!-- {% cart_count %} -->
                  </span>
                </a>
              </div>
            </div>
            <div
              id="mobile-menu"
              class="fixed inset-0 z-20 bg-white w-full h-full shadow-lg transform -translate-x-full transition-transform md:hidden"
            >
              <div class="p-4">
                <div class="flex items-center justify-between ">
                  <img
                    id="navbarLogo"
                    src=""
                    alt="Logo"
                    class="w-20 h-16 md:h-20 cursor-pointer object-contain"
                  />
                  <button id="close-menu" class="p-2 ">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="#0D0D0D"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div class="mt-4 flex flex-col space-y-4 mobile-nav-links">
                  ${navLinks}
                </div>
              </div>
            </div>
          </nav>
        `,

        script: function () {
          const currentPath =
            window.location.pathname.replace(/\/$/, "") || "/";
          const navLinks = document.querySelectorAll(
            ".nav-links a, .mobile-nav-links a"
          );
          function setActiveLink(path) {
            const navLinksArray = Array.from(navLinks);
            navLinksArray.forEach((nav) =>
              nav.classList.remove("border-[var(--primary)]", "border-b-2")
            );
            const activeLink = navLinksArray.find((link) => {
              const linkPath = link.getAttribute("href");
              return linkPath === path;
            });

            if (activeLink) {
              activeLink.classList.add("border-[var(--primary)]", "border-b-2");
            }
          }
          setActiveLink(currentPath);
          document
            .getElementById("menu-toggle")
            .addEventListener("click", function () {
              document
                .getElementById("mobile-menu")
                .classList.remove("-translate-x-full");
            });

          document
            .getElementById("close-menu")
            .addEventListener("click", function () {
              document
                .getElementById("mobile-menu")
                .classList.add("-translate-x-full");
            });
          document
            .querySelectorAll("#mobile-menu .nav-link")
            .forEach((link) => {
              link.addEventListener("click", function () {
                document
                  .getElementById("mobile-menu")
                  .classList.add("-translate-x-full");
              });
            });
        },
        toolbar: [
          {
            attributes: { class: "fa fa-trash-o" },
            command: "tlb-delete",
          },
          {
            attributes: { class: "fa fa-gear" },
            command: "navbar-edit",
          },
        ],
      },
    },
  });
};
